export const GET_CUSTOMER_PRODUCTS = 'productsChoice/GET_CUSTOMER_PRODUCTS';
export const GET_CUSTOMER_PRODUCTS_FAILED = 'productsChoice/GET_CUSTOMER_PRODUCTS_FAILED';
export const GET_CUSTOMER_PRODUCTS_SUCCESS = 'productsChoice/GET_CUSTOMER_PRODUCTS_SUCCESS';
